import { createContext } from "react";

export const profileContext = createContext();
export const lastUrlContext = createContext();
